// @flow
import React, { useState } from 'react'
// import { EditorState } from 'draft-js'
import Avatar from '@components/app/avatar'
import Editor from '@components/app/editor/comment'
import Button from '@components/common/button'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from './messages'
import styles from './comments.module.scss'

interface Props {
  user: {
    // eslint-disable-next-line camelcase
    user_image: string
    name: string
  }
  onSubmit: (text: string) => void
  submitting: boolean
}

const CommentInput = ({ user, onSubmit, submitting }: Props) => {
  const intl = useIntl()
  const [ editorState, setEditorState ] = useState('')
  const [ isActive, setActive ] = useState(false)

  const onCancel = () => {
    setEditorState('')
    setActive(false)
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onChange = (state: any) => {
    setEditorState(state)
    setActive(isActive || state.length > 0)
  }

  const onCommentSubmit = async () => {
    // eslint-disable-next-line no-console
    console.log(editorState)
    const result = await onSubmit(editorState)
    onCancel()
    // eslint-disable-next-line no-console
    console.log(result)
  }

  return (
    <div className="d-flex">
      <div className="flex0 mr-3">
        <Avatar
          src={user.user_image}
          alt={user.name}
          className={styles.avatar}
        />
      </div>
      <div className="flex1">
        <div className={`${styles.editor} mb-3 p-2`}>
          <Editor
            comment={editorState}
            onChange={onChange}
            placeholder={intl.formatMessage(messages.placeholder)}
            readOnly={submitting}
          />
        </div>
        {isActive && (
          <div className="tx-right">
            <Button className="link" onClick={onCancel}>
              <FormattedMessage id="app.cancel" defaultMessage="Cancel" />
            </Button>
            <Button className="primary" onClick={onCommentSubmit}>
              <FormattedMessage {...messages.addComment} />
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}

export default CommentInput
